import React from 'react';
import { useLocation } from 'react-router-dom';
import useAuth from 'features/auth/hooks/useAuth';

const AutoLogin = () => {
  const { onAutoLogin } = useAuth();

  const search = useLocation().search;

  React.useEffect(() => {
    const autologin_token = new URLSearchParams(search).get('token');

    if(autologin_token) {
      onAutoLogin(autologin_token);
    }
  }, [onAutoLogin, search])

  return (
    <></>
  );
};

export default AutoLogin;
